import { createContext } from "react";
import { format, isValid } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export type DateUtilsConfig = {
  convertToServerTime: (date: Date | null) => string | number | null;
  convertFromServerTime: (value: string | number) => Date | null;
  formatDateStringBase: (value: string | number | Date | null, _format: string, timeZone: string, invalidDate?: string | null | undefined) => string;
  formatDateString: (value: string | number | Date | null, format: string, timeZone: string) => string
}

const convertToServerTime = (date: Date | null) => date?.toISOString() ?? null;
const convertFromServerTime = (value: string | number | null) => value ? new Date(value) : null;
const formatDateStringBase = (value: string | number | Date | null, _format: string, timeZone: string, invalidDate?: string | null) => {
  if (!value) return "";

  const date = value instanceof Date ? value : convertFromServerTime(value)!;

  return isValid(date)
    //todo think about zone transformation
    ? format(toZonedTime(date, timeZone), _format)
    : invalidDate ?? "Invalid date";
};
const formatDateString = (value: string | number | Date | null, format: string, timeZone: string) => {
  return formatDateStringBase(value, format, timeZone, "Invalid date");
};

export const defaultDateUtils: DateUtilsConfig = {
  convertToServerTime,
  convertFromServerTime,
  formatDateStringBase,
  formatDateString,
};

Object.freeze(defaultDateUtils);

export const DateUtilsContext = createContext<DateUtilsConfig>(defaultDateUtils);